import BatchPrescreenError from './Error';

export default BatchPrescreenError;
